import { WalletConnectConnector } from '@web3-react/walletconnect-connector'
import { toast } from 'react-toastify'

const POLLING_INTERVAL = 3000
const wcConnector = new WalletConnectConnector({
  rpc: {
    56: "https://bsc-dataseed1.binance.org/"
  },
  chainId: 56,
  network: "binance",
  qrcode: true,
  qrcodeModalOptions: {
    mobileLinks: [
      "metamask",
      "trust"
    ]
  },
  pollingInterval: POLLING_INTERVAL
})

wcConnector.on('Web3ReactDeactivate', () => {
  window.localStorage.removeItem('userData')
  toast.warn('Disconnect form trust wallet', {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
})

export default wcConnector